(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-pdp-gif-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const detectStickyOffset = () => {
    const candidates = document.querySelectorAll(
      '[data-sticky-header], .shopify-section-header-sticky, .site-header, header[sticky], .header'
    );
    let max = 0;
    candidates.forEach(el => {
      const cs = getComputedStyle(el);
      if (/(fixed|sticky)/.test(cs.position) && el.offsetParent !== null) {
        max = Math.max(max, el.getBoundingClientRect().height);
      }
    });
    return max;
  };

  const init = (root) => {
    if (!root || root.dataset.dkFaqInited === '1') return;
    root.dataset.dkFaqInited = '1';

    // Optional per-section CSS offset: --dk-faq-scroll-offset
    const cssOffset = parseInt(getComputedStyle(root).getPropertyValue('--dk-faq-scroll-offset')) || 0;
    const extraOffset = 200; // 👈 your requested cushion above the summary

    // Play the video
    const video = root.querySelector('.dk-comparison-media');

    if (video && video.hasAttribute('autoplay')) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.playsInline = true;

      const tryPlay = () => {
        const p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {}); // swallow autoplay rejections
        }
      };

      // initial attempt
      tryPlay();

      // retries for timing quirks (very common with Shopify sections)
      setTimeout(tryPlay, 150);
      setTimeout(tryPlay, 500);
    }

    const items = root.querySelectorAll('.dk-faq details.dk-faq__item');
    if (!items.length) return;

    // Open the first on load if none are open (no scroll on init)
    if (![...items].some(d => d.open)) items[0].open = true;

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

    const scrollToSummary = (summaryEl) => {
      const headerOffset = detectStickyOffset();
      const offset = Math.max(headerOffset, cssOffset) + extraOffset;

      const targetTop = window.scrollY + summaryEl.getBoundingClientRect().top - offset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

      window.scrollTo({
        top: clamp(targetTop, 0, maxScroll),
        behavior: 'smooth'
      });
    };

    items.forEach((detailsEl) => {
      const summary = detailsEl.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        // Wait one frame for native <details> to set .open
        requestAnimationFrame(() => {
          if (!detailsEl.open) return; // it was a close; ignore

          // Close others
          items.forEach((other) => { if (other !== detailsEl) other.open = false; });

          // Always scroll opened summary into view with header + 200px offset
          scrollToSummary(summary);
        });
      }, { passive: true });
    });
  };

  // Init all existing instances
  document.querySelectorAll('.dk-video-faq').forEach(init);

  // Re-init on Theme Editor section loads / dynamic mounts
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.dk-video-faq').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-section-pinwheel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPinwheel() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.config({
      ignoreMobileResize: true,
      autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
    });
    window.addEventListener("orientationchange", () => {
      setTimeout(() => ScrollTrigger.refresh(), 300);
    }, { passive: true });

    let refreshHooksMounted = false;
    const kickRefresh = (() => {
      const dc = gsap.delayedCall(0.15, () => ScrollTrigger.refresh()).pause();
      return () => dc.restart(true);
    })();
    function mountRefreshHooks(topOfEl) {
      if (refreshHooksMounted) return;
      refreshHooksMounted = true;

      window.addEventListener("load", () => setTimeout(kickRefresh, 120));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(kickRefresh);
      ["shopify:section:load","shopify:section:reorder","shopify:section:select","shopify:section:deselect"]
        .forEach(evt => document.addEventListener(evt, () => setTimeout(kickRefresh, 50)));
      if (typeof topOfEl === "number") {
        Array.prototype.forEach.call(document.images, (img) => {
          if (!img.complete) {
            const imgTop = img.getBoundingClientRect().top + window.scrollY;
            if (imgTop < topOfEl) {
              img.addEventListener("load",  kickRefresh, { once: true });
              img.addEventListener("error", kickRefresh, { once: true });
            }
          }
        });
      }
      if (!ScrollTrigger.isTouch) {
        window.addEventListener("resize", kickRefresh);
      }
    }

    ScrollTrigger.matchMedia({
      /* ------------------ DESKTOP ------------------ */
      "(min-width: 701px)": function () {
        const section = document.querySelector("#dk-pinwheel-section");
        if (!section) return;
        const sticky  = section.querySelector(".pinwheel__sticky");
        const titleOv = section.querySelector(".pinwheel__title-overlay");
        const textEls = gsap.utils.toArray(section.querySelectorAll(".pinwheel__text-block"));
        const wheel   = section.querySelector(".pinwheel__wheel");

        let rotor = section.querySelector(".pinwheel__wheel-rotor");
        if (!rotor) {
          rotor = document.createElement("div");
          rotor.className = "pinwheel__wheel-rotor";
          const arms = Array.from(wheel.children);
          rotor.append(...arms);
          wheel.appendChild(rotor);
        }

        const SEG        = Math.round(window.visualViewport?.height || window.innerHeight);
        const HOLDUNIT   = SEG * 0.20;
        const HALFTRAVEL = SEG * 0.50;
        const FADE_WIN   = SEG * 0.10;

        const STEP = 72;
        const HALFSTEP = 36;

        const OFFSET = parseFloat(section.dataset.rotorOffset || "54");
        const absDeg = (deg) => deg + OFFSET;

        const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        let reducedTrigger = null;
        if (prefersReduced) {
          reducedTrigger = ScrollTrigger.create({
            trigger: section, start: "top top", end: "bottom bottom", pin: sticky
          });
          gsap.set(titleOv, { opacity: 0 });
          textEls.forEach((el, i) => {
            const on = i === 0;
            el.classList.toggle("active", on);
            el.setAttribute("aria-hidden", on ? "false" : "true");
            gsap.set(el, { opacity: on ? 1 : 0 });
          });
          mountRefreshHooks(section.getBoundingClientRect().top + window.scrollY);
          return () => { reducedTrigger && reducedTrigger.kill(); };
        }

        gsap.set(rotor, { rotation: absDeg(0) });

        const slides = Math.min(textEls.length, 4);
        const HOLD_F = 0.20;
        const endSegs = 1 + Math.max(0, slides - 1) * (1 + HOLD_F) + (0.5 + HOLD_F);
        section.style.setProperty("--desktop-runway", (endSegs * 100).toFixed(2));

        const tlRot = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: () => "top top",
            end:   () => "bottom bottom",
            scrub: true,
            pin: sticky,
            pinSpacing: false,
            invalidateOnRefresh: true,
            anticipatePin: 1
          }
        });

        tlRot.addLabel("spacerStart");
        tlRot.to(rotor, { rotation: absDeg(HALFSTEP), duration: SEG, ease: "none" });
        tlRot.addLabel("spacerEnd");

        function addBlockFull(i, centerDeg) {
          const base = `b${i}`;
          tlRot.addLabel(`${base}Start`);
          tlRot.to(rotor, { rotation: absDeg(centerDeg),            duration: HALFTRAVEL, ease: "none" });
          tlRot.addLabel(`${base}CenterIn`);
          tlRot.to(rotor, { rotation: absDeg(centerDeg),            duration: HOLDUNIT,   ease: "none" });
          tlRot.addLabel(`${base}CenterOut`);
          tlRot.to(rotor, { rotation: absDeg(centerDeg + HALFSTEP), duration: HALFTRAVEL, ease: "none" });
          tlRot.addLabel(`${base}End`);
        }
        function addBlockLast(i, centerDeg) {
          const base = `b${i}`;
          tlRot.addLabel(`${base}Start`);
          tlRot.to(rotor, { rotation: absDeg(centerDeg), duration: HALFTRAVEL, ease: "none" });
          tlRot.addLabel(`${base}CenterIn`);
          tlRot.to(rotor, { rotation: absDeg(centerDeg), duration: HOLDUNIT,   ease: "none" });
          tlRot.addLabel(`${base}CenterOut`);
        }

        const centers = [108, 180, 252, 324].slice(0, slides);
        centers.forEach((deg, idx) => {
          const i = idx + 1;
          if (i < slides) addBlockFull(i, deg);
          else            addBlockLast(i, deg);
        });

        tlRot.fromTo(
          titleOv,
          { opacity: 1 },
          {
            opacity: 0,
            ease: "none",
            duration: FADE_WIN,
            onStart:    () => titleOv.setAttribute("aria-hidden", "false"),
            onComplete: () => titleOv.setAttribute("aria-hidden", "true")
          },
          `spacerEnd-=${FADE_WIN}`
        );

        textEls.forEach((block, idx) => {
          const n = idx + 1;
          gsap.set(block, { opacity: 0 });

          tlRot.fromTo(
            block,
            { opacity: 0 },
            {
              opacity: 1,
              ease: "none",
              duration: FADE_WIN,
              onStart: () => {
                block.classList.add("active");
                block.setAttribute("aria-hidden", "false");
              }
            },
            `b${n}CenterIn-=${FADE_WIN}`
          );

          if (n !== slides) {
            tlRot.to(
              block,
              {
                opacity: 0,
                ease: "none",
                duration: FADE_WIN,
                onComplete: () => {
                  block.classList.remove("active");
                  block.setAttribute("aria-hidden", "true");
                }
              },
              `b${n}End`
            );
          }
        });

        const tlAfter = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: () => "bottom bottom",
            end:   () => "+=" + HALFTRAVEL,
            scrub: true,
            invalidateOnRefresh: true
          }
        });
        tlAfter.to(rotor, { rotation: "+=" + HALFSTEP, ease: "none" });

        function applyStateNow() {
          const aAbs = ((gsap.getProperty(rotor, "rotation") % 360) + 360) % 360;
          const aRel = ((aAbs - OFFSET) % 360 + 360) % 360;

          const inSpacer = aRel < HALFSTEP;
          titleOv.setAttribute("aria-hidden", inSpacer ? "false" : "true");
          gsap.set(titleOv, { opacity: inSpacer ? 1 : 0 });

          const slides = Math.min(textEls.length, 4);
          if (!inSpacer) {
            const idx = Math.min(slides - 1, Math.floor((aRel - HALFSTEP) / STEP));
            textEls.forEach((el, i) => {
              const on = i === idx;
              el.classList.toggle("active", on);
              el.setAttribute("aria-hidden", on ? "false" : "true");
              gsap.set(el, { opacity: on ? 1 : 0 });
            });
          } else {
            textEls.forEach(el => {
              el.classList.remove("active");
              el.setAttribute("aria-hidden", "true");
              gsap.set(el, { opacity: 0 });
            });
          }
        }
        applyStateNow();
        ScrollTrigger.addEventListener("refresh", applyStateNow);

        mountRefreshHooks(section.getBoundingClientRect().top + window.scrollY);

        return () => { tlRot.kill(); };
      },

      /* ------------------ MOBILE ------------------ */
      "(max-width: 700px)": function () {
        const section = document.querySelector("#dk-pinwheel-section");
        const mob     = section?.querySelector(".section-mobile");
        if (!section || !mob) return;

        const sticky  = mob.querySelector(".pm__sticky");
        const titleEl = mob.querySelector(".pm__title");
        const texts   = gsap.utils.toArray(mob.querySelectorAll(".pm__text-block"));
        const stack   = mob.querySelector(".pm__stack");
        const cards   = gsap.utils.toArray(stack.querySelectorAll(".pm__card"));

        const SEG   = Math.round(window.visualViewport?.height || window.innerHeight);
        const HOLD_F = 0.20;

        const fullCards = Math.max(0, cards.length - 1);
        const endSegs =
          0.35 +                       // intro
          fullCards * (0.5 + HOLD_F) + // per card
          0.25;
        section.style.setProperty("--mobile-runway", ((1 + endSegs) * 100).toFixed(2));

        mob.removeAttribute("aria-hidden");
        gsap.set(titleEl, { opacity: 1 });
        titleEl.setAttribute("aria-hidden", "false");
        texts.forEach(el => { gsap.set(el, { opacity: 0 }); el.setAttribute("aria-hidden", "true"); });

        // base positioning — fan out, but simple transforms
        cards.forEach((card, i) => {
          const offsetX = -5 * i;
          const offsetY = -10 * i;
          gsap.set(card, { x: offsetX, y: offsetY });
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top top",
            end:   "bottom bottom",
            scrub: 0.35,
            pin: sticky,
            pinSpacing: false,
            invalidateOnRefresh: true,
            anticipatePin: 1
          }
        });

        // intro: fade title → show first text
        tl.to(titleEl, {
          opacity: 0,
          duration: SEG * 0.15,
          ease: "none",
          onComplete: () => titleEl.setAttribute("aria-hidden", "true")
        });

        if (texts[0]) {
          tl.fromTo(texts[0],
            { opacity: 0 },
            {
              opacity: 1,
              duration: SEG * 0.10,
              ease: "none",
              onStart: () => {
                texts[0].classList.add("active");
                texts[0].setAttribute("aria-hidden","false");
              }
            }
          );
        }

        cards.forEach((card, i) => {
          const isLast = i === cards.length - 1;
          const label  = `card-${i}`;
          const travel = isLast ? -(SEG * 0.12) : -(SEG * 0.50);

          tl.addLabel(label);

          // lift current card (GPU-friendly)
          tl.to(card, {
            y: `+=${travel}`,
            duration: SEG * (isLast ? 0.25 : 0.50),
            ease: "none"
          }, label);

          // hold
          if (!isLast) {
            tl.to({}, { duration: SEG * HOLD_F }, `${label}+=0`);
          }

          // text swap
          const curr = texts[i];
          const next = texts[i+1];
          if (!isLast && next) {
            tl.to(card, {
              opacity: 0,
              duration: SEG * 0.10,
              ease: "none"
            }, `${label}+=${SEG * 0.40}`);

            tl.to(curr, {
              opacity: 0,
              duration: SEG * 0.10,
              ease: "none",
              onComplete: () => {
                curr.classList.remove("active");
                curr.setAttribute("aria-hidden","true");
              }
            }, `${label}+=${SEG * 0.40}`);

            tl.fromTo(next, { opacity: 0 }, {
              opacity: 1,
              duration: SEG * 0.10,
              ease: "none",
              onStart: () => {
                next.classList.add("active");
                next.setAttribute("aria-hidden","false");
              }
            }, `${label}+=${SEG * 0.40}`);
          }

          // nudge rest forward (like your --shift)
          const rest = cards.slice(i + 1);
          if (rest.length) {
            tl.to(rest, {
              x: (idx, target) => gsap.getProperty(target, "x") + 5,
              y: (idx, target) => gsap.getProperty(target, "y") + 5,
              duration: Math.min(SEG * 0.12, 0.25),
              ease: "power2.out"
            }, `${label}+=${SEG * 0.35}`);
          }
        });

        mountRefreshHooks(section.getBoundingClientRect().top + window.scrollY);

        return () => { tl.kill(); };
      }
    });
  }

  if (document.readyState === 'complete') {
    (window.requestIdleCallback
      ? requestIdleCallback(initPinwheel, { timeout: 1200 })
      : setTimeout(initPinwheel, 0)
    );
  } else {
    window.addEventListener('load', function () {
      (window.requestIdleCallback
        ? requestIdleCallback(initPinwheel, { timeout: 1200 })
        : setTimeout(initPinwheel, 0)
      );
    }, { once: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-quiz"] && !Shopify.designMode) return;
  try {
    

(function(d,s,id,u){
  if (d.getElementById(id)) return;
  var js, sjs = d.getElementsByTagName(s)[0],
      t = Math.floor(new Date().getTime() / 1000000);
  js=d.createElement(s); js.id=id; js.async=1; js.src=u+'?'+t;
  sjs.parentNode.insertBefore(js, sjs);
}(document, 'script', 'os-widget-jssdk', 'https://www.opinionstage.com/assets/loader.js'));


  } catch(e) { console.error(e); }
})();
})();
